class ComparisonFilter {
    id: KnockoutObservable<string>; 
    name: KnockoutObservable<string>; 
    color: KnockoutObservable<string>;
    showValue: KnockoutObservable<boolean>; 
    showVariation: KnockoutObservable<boolean>; 
    showPercentageVariation: KnockoutObservable<boolean>;
    dateOption: KnockoutObservable<ComparisonDateOptionEnum> = ko.observable(ComparisonDateOptionEnum.Previous);
    dateUnit: KnockoutObservable<ComparisonDateUnitEnum> = ko.observable(ComparisonDateUnitEnum.Year);
    dateUnitValue: KnockoutObservable<number> = ko.observable(1);
    //dateField: Field; 
    dateField: KnockoutObservable<number>;
    //dateRange: DateRange = DateRangeService.LastMonth;
    dateRange: KnockoutObservable<number>; // = DateRangeService.LastMonth;
    comparisonFilterIdBase: KnockoutObservable<string>; 
    filters: KnockoutObservableArray<Filter>;

    predefinedCustomDate: KnockoutObservable<string>;

    //Used to disable/enable the Apply button on the Drilldown Filters tab
    isDirty: KnockoutObservable<boolean>;

    constructor(data) {
        this.id = ko.observable(data.id);
        this.name = ko.observable(data.name);
        this.color = ko.observable(data.color);
        this.showValue = ko.observable(data.showValue);
        this.showVariation = ko.observable(data.showVariation);
        this.showPercentageVariation = ko.observable(data.showPercentageVariation);
        if (data.dateOption !== null && data.dateOption !== undefined) {
            this.dateOption(data.dateOption);
        }
        if (data.dateUnit !== null && data.dateUnit !== undefined) {
            this.dateUnit(data.dateUnit);
        } 
        if (data.dateUnitValue !== null && data.dateUnitValue !== undefined) {
            this.dateUnitValue(data.dateUnitValue);
        } 
        this.dateField = ko.observable(data.dateField);
        this.dateRange = ko.observable(data.dateRange);
        this.comparisonFilterIdBase = ko.observable(data.comparisonFilterIdBase);
        this.predefinedCustomDate = ko.observable(data.predefinedCustomDate);

        this.filters = ko.observableArray(createInstances(Filter, data.filters as Array<any>));

        this.isDirty = ko.observable(false);
    }
}